import i18n from "i18n";

const columns = [
  {
    // Razón social
    name: "business_name",
    pill: false,
    title: i18n.t("company.name").toUpperCase(),
    mobileTag: false
  },
  {
    // Nombre
    name: "name",
    pill: false,
    title: i18n.t("name").toUpperCase(),
    mobileTag: false,
    // mobileTag: `${i18n.t("name")}:`
  },
  {
    // Dirección
    name: "address",
    pill: false,
    title: i18n.t("address").toUpperCase(),
    mobileTag: `${i18n.t("address")}:`,
  },
  {
    // Municipio
    name: "locality",
    pill: false,
    title: i18n.t("municipality").toUpperCase(),
    mobileTag: false,
    // mobileTag: `${i18n.t("municipality")}:`
  },
  {
    // Provincia
    name: "state",
    pill: false,
    title: i18n.t("province").toUpperCase(),
    mobileTag: false,
    // mobileTag: `${i18n.t("province")}:`
  }
];

export default columns;
